/**
 * ContractorsListRoute — skin-aware switcher for /contractors.
 *
 * Cockpit skin returns a full structural rewrite; classic returns the
 * original list untouched.
 */
import { useUISkin } from "@/data/UISkinContext";
import ContractorsList from "./ContractorsList";
import ContractorsListCockpit from "./ContractorsListCockpit";

export default function ContractorsListRoute() {
  const { skin } = useUISkin();
  if (skin === "cockpit") return <ContractorsListCockpit />;
  return <ContractorsList />;
}
